export const GATES = {
  ASK_WHY_AUTOMATION: 'ask_why_automation',
  ATTENTION_CHECK: 'red_herring',
  CARRY_FORWARD: 'carry_forward',
  CARRY_FORWARD_INTO_GRID: 'carry_forward_into_grid',
  CUSTOM_CROSSTAB_BUILDER: 'custom_crosstabs',
  DISPLAY_FULL_QNR_IN_REPORT: 'display_full_qnr_in_report',
  GLOBAL_FILTERS_REDESIGN: 'global_filters_redesign',
  INSTANT_SURVEY_AUTO_SAVE: 'auto_save_survey',
  INSTANT_SURVEY_MAINTENANCE: 'instant_survey_maintenance',
  MULTI_LEVEL_DISQUALIFY: 'multi_level_disqualify',
  MULTIPLE_SUBSCRIPTIONS_REVAMP: 'multiple_subscriptions_revamp',
  PREVIEW_SURVEY: 'preview_survey',
  QUESTION_GROUP_BLOCKS: 'question_group_blocks',
  QUESTION_LIBRARY: 'question_library',
  QUESTION_OPTION_LOGIC: 'question_option_logic',
  QUESTION_TYPE_AI_INTERVIEW: 'question_type_ai_interview',
  QUESTION_TYPE_VIDEO: 'video_survey',
  REORGANIZED_QUESTION_TYPES: 'reorganized_question_types',
  REQUIRE_QUESTION_TYPE_SELECTION: 'require_question_type_selection',
  RESPONSE_QUALITY_TAB: 'response_quality_tab',
  RICH_TEXT_FORMATTING: 'rich_text_formatting',
  SCREENER_QUESTIONS: 'screener_questions',
  SEQUENTIAL_MONADIC: 'sequential_monadic',
  SEQUENTIAL_MONADIC_MODEL_MIGRATION: 'sequential_monadic_model_migration',
  SHOW_CREDITS: 'show_credits',
  SHOW_QNR_AI_AND_TEMPLATE_BLOCKS: 'show_qnr_ai_and_template_blocks',
  SOFT_LAUNCH: 'soft_launch',
  STANDARD_SURVEY: 'standard_survey',
  START_SURVEY_NON_LINEAR: 'start_survey_non_linear',
  SURVEY_DASHBOARD_FULL_WIDTH: 'survey_dashboard_full_width',
  SURVEY_DASHBOARD_V2_RESPONSES: 'survey_dashboard_v2_responses',
  SURVEY_INCLUDE_DISQUALIFIED_RESPONSES: 'survey_include_disqualified_responses',
  SURVEY_MENU_REFACTOR: 'survey_menu_refactor',
  SURVEY_RESPONSES_SIGNIFICANCE: 'survey_responses_significance',
  SURVEY_TRANSLATION: 'survey_translation',
  TURF_SIMULATOR: 'turf_simulator',
  USE_CALYPSO_AS_SURVEY_PROVIDER: 'use_calypso_as_survey_provider',
  VAN_WESTENDORP: 'van_westendorp',
  VIDEO_SIZZLE_REEL: 'video_sizzle_reel_enabled',
};
